/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Topsellers1Inputs */

const id_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlaris`)
};

const ms_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlaris`)
};

const da_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedst sælgende`)
};

const de_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meistverkauft`)
};

const en_us2_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top sellers`)
};

const es_es2_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más vendidos`)
};

const es_mx2_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más vendidos`)
};

const fil_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakamabenta`)
};

const fr_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleures ventes`)
};

const it_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più venduti`)
};

const hu_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legkelendőbbek`)
};

const nl_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best verkopend`)
};

const no_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest solgte`)
};

const pl_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepiej sprzedawane`)
};

const pt_br2_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais vendidos`)
};

const pt_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais vendidos`)
};

const ro_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best-seller`)
};

const fi_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Myydyimmät`)
};

const sv_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bästsäljare`)
};

const vi_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán chạy nhất`)
};

const tr_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En çok satanlar`)
};

const cs_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejprodávanější`)
};

const bg_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-продавани`)
};

const ru_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лидеры продаж`)
};

const uk_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найпродаваніші`)
};

const ar_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأكثر مبيعًا`)
};

const hi_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप सेलर्स`)
};

const th_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขายดีที่สุด`)
};

const ja_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トップセラー`)
};

const zh_cn2_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`畅销产品`)
};

const zh_hant1_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暢銷產品`)
};

const ko_home_hero_topsellers1 = /** @type {(inputs: Home_Hero_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최고 판매`)
};

/**
* | output |
* | --- |
* | "Top sellers" |
*
* @param {Home_Hero_Topsellers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_hero_topsellers1 = /** @type {((inputs?: Home_Hero_Topsellers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Topsellers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_hero_topsellers1(inputs)
	if (locale === "ms") return ms_home_hero_topsellers1(inputs)
	if (locale === "da") return da_home_hero_topsellers1(inputs)
	if (locale === "de") return de_home_hero_topsellers1(inputs)
	if (locale === "en-US") return en_us2_home_hero_topsellers1(inputs)
	if (locale === "es-ES") return es_es2_home_hero_topsellers1(inputs)
	if (locale === "es-MX") return es_mx2_home_hero_topsellers1(inputs)
	if (locale === "fil") return fil_home_hero_topsellers1(inputs)
	if (locale === "fr") return fr_home_hero_topsellers1(inputs)
	if (locale === "it") return it_home_hero_topsellers1(inputs)
	if (locale === "hu") return hu_home_hero_topsellers1(inputs)
	if (locale === "nl") return nl_home_hero_topsellers1(inputs)
	if (locale === "no") return no_home_hero_topsellers1(inputs)
	if (locale === "pl") return pl_home_hero_topsellers1(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_topsellers1(inputs)
	if (locale === "pt") return pt_home_hero_topsellers1(inputs)
	if (locale === "ro") return ro_home_hero_topsellers1(inputs)
	if (locale === "fi") return fi_home_hero_topsellers1(inputs)
	if (locale === "sv") return sv_home_hero_topsellers1(inputs)
	if (locale === "vi") return vi_home_hero_topsellers1(inputs)
	if (locale === "tr") return tr_home_hero_topsellers1(inputs)
	if (locale === "cs") return cs_home_hero_topsellers1(inputs)
	if (locale === "bg") return bg_home_hero_topsellers1(inputs)
	if (locale === "ru") return ru_home_hero_topsellers1(inputs)
	if (locale === "uk") return uk_home_hero_topsellers1(inputs)
	if (locale === "ar") return ar_home_hero_topsellers1(inputs)
	if (locale === "hi") return hi_home_hero_topsellers1(inputs)
	if (locale === "th") return th_home_hero_topsellers1(inputs)
	if (locale === "ja") return ja_home_hero_topsellers1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_hero_topsellers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_hero_topsellers1(inputs)
	return ko_home_hero_topsellers1(inputs)
});
export { home_hero_topsellers1 as "home.hero.topSellers" }